// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__PBC-v","footer__button":"footer_footer__button__OAdwy"};